import { CheckRounded, CloseRounded, SyncAltRounded } from '@mui/icons-material';
import { Skeleton } from '@mui/material';
import {
  isCon,
  isPro,
  JudgmentCounts,
  judgmentCountsConCss,
  judgmentCountsNeutralCss,
  judgmentCountsProCss
} from 'features/fact-grabbing/useReferencesByClaim';
import styled from 'styled-components';

type Props = {
  judgmentCounts: JudgmentCounts;
  isLoading: boolean;
  isError: boolean;
};

export const ClaimReferencesStatusIcon = ({ isError, isLoading, judgmentCounts }: Props) => {
  if (isLoading || isError) {
    return <Skeleton variant="circular" width={24} height={24} />;
  }

  if (isPro(judgmentCounts)) {
    return <ProStatusIcon />;
  }

  if (isCon(judgmentCounts)) {
    return <ConStatusIcon />;
  }

  return <NeutralStatusIcon />;
};

const ProStatusIcon = styled(CheckRounded)`
  ${judgmentCountsProCss};
`;

const ConStatusIcon = styled(CloseRounded)`
  ${judgmentCountsConCss};
`;

const NeutralStatusIcon = styled(SyncAltRounded)`
  ${judgmentCountsNeutralCss};
`;
